<template>

  <div>
    <Toolbar>
      <template #right>
        <Dropdown id="season-select" v-model="selectedSubscription" :options="subscriptions" optionLabel="getSeasonYear"
                  placeholder="Wähle eine Saison"
                  v-on:change="switchSubscription">
          <template #value="slotProps">
            <div v-if="slotProps.value">
              <div>{{ getSeasonYear(slotProps.value) }}</div>
            </div>
            <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
          </template>
          <template #option="slotProps">
            <div>
              <div>{{ getSeasonYear(slotProps.option) }}</div>
            </div>
          </template>
        </Dropdown>

      </template>

    </Toolbar>

    <TabView class="p-mt-3">

      <TabPanel header="Gewinn je Spieler">
        <p>Irgenbdein Text</p>

        <div class="p-fluid p-grid p-mt-3">
          <Panel>
            <!-- Data Table for small devices -->
            <DataTable :value="profits.userProfits"
                       :scrollable="true" scrollHeight="flex"
                       :style="{height: '70vh'}"
                       ref="dt"
                       :loading="isLoading"
                       class="p-datatable-sm"
                       sortField="name"
                       :sortOrder="-1">

              <template #header>
                <div style="text-align: left">
                  <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
                </div>
              </template>

              <template #empty>
                No Users found
              </template>

              <template #loading>
                Loading...
              </template>

              <Column field="userDayRanking" header="#" headerStyle="width:2em">
                <template #body="slotProps">
                  <span>{{ slotProps.data.userDayRanking }}</span>
                </template>
              </Column>

              <Column field="surname" header="Name">
              </Column>

              <Column field="name" header="Vorname">
              </Column>

              <Column field="finalSeasonRank" header="Platzierung">
              </Column>

<!--
              <Column v-for="day of profits.userProfits.dayProfits" :field="day.dayNumber" :header="day.dayNumber" :key="day._id">
                {{day.profit}}
              </Column>
-->
              <Column field="day1Profit" header="1">
                <template #body="slotProps">
<!--                  <div>{{getTwoDigitNumber(slotProps.data.day1Profit)}}</div>-->
                  <div>{{ slotProps.data.dayProfits[0].profit}}</div>
                </template>
              </Column>

              <Column field="day2Profit" header="2">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[1].profit }}</div>
                </template>
              </Column>

              <Column field="day3Profit" header="3" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[2].profit }}</div>
                </template>
              </Column>
              <Column field="day4Profit" header="4" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[3].profit }}</div>
                </template>
              </Column>
              <Column field="day5Profit" header="5" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[4].profit }}</div>
                </template>
              </Column>
              <Column field="day6Profit" header="6" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[5].profit }}</div>
                </template>
              </Column>
              <Column field="day7Profit" header="7" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[6].profit }}</div>
                </template>
              </Column>
              <Column field="day8Profit" header="8" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[7].profit }}</div>
                </template>
              </Column>
              <Column field="day9Profit" header="9" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[8].profit }}</div>
                </template>
              </Column>
              <Column field="day10Profit" header="10" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[9].profit }}</div>
                </template>
              </Column>
              <Column field="day11Profit" header="11" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[10].profit }}</div>
                </template>
              </Column>
              <Column field="day12Profit" header="12" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[11].profit }}</div>
                </template>
              </Column>
              <Column field="day13Profit" header="13" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[12].profit }}</div>
                </template>
              </Column>
              <Column field="day14Profit" header="14" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[13].profit }}</div>
                </template>
              </Column>
              <Column field="day15Profit" header="15" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[14].profit }}</div>
                </template>
              </Column>
              <Column field="day16Profit" header="16" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[15].profit }}</div>
                </template>
              </Column>
              <Column field="day17Profit" header="17" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[16].profit }}</div>
                </template>
              </Column>
              <Column field="day18Profit" header="18" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[17].profit }}</div>
                </template>
              </Column>
              <Column field="day19Profit" header="19" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[18].profit }}</div>
                </template>
              </Column>
              <Column field="day20Profit" header="20" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[19].profit }}</div>
                </template>
              </Column>
              <Column field="day21Profit" header="21" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[20].profit }}</div>
                </template>
              </Column>
              <Column field="day22Profit" header="22" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[21].profit }}</div>
                </template>
              </Column>
              <Column field="day23Profit" header="23" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[22].profit }}</div>
                </template>
              </Column>
              <Column field="day24Profit" header="24" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[23].profit }}</div>
                </template>
              </Column>
              <Column field="day25Profit" header="25" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[24].profit }}</div>
                </template>
              </Column>
              <Column field="day26Profit" header="26" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[25].profit }}</div>
                </template>
              </Column>
              <Column field="day27Profit" header="27" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[26].profit }}</div>
                </template>
              </Column>
              <Column field="day28Profit" header="28" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[27].profit }}</div>
                </template>
              </Column>
              <Column field="day29Profit" header="29" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[28].profit }}</div>
                </template>
              </Column>
              <Column field="day30Profit" header="30" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[29].profit }}</div>
                </template>
              </Column>
              <Column field="day31Profit" header="31" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[30].profit }}</div>
                </template>
              </Column>
              <Column field="day32Profit" header="32" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[31].profit }}</div>
                </template>
              </Column>
              <Column field="day33Profit" header="33" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[32].profit }}</div>
                </template>
              </Column>
              <Column field="day34Profit" header="34" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[33].profit }}</div>
                </template>
              </Column>

              <Column field="day34SumProfit" header="Gesamt" header-style="text-align: right"
                      body-style="text-align: right">
                <template #body="slotProps">
                  <div>{{ slotProps.data.dayProfits[33].sumProfit }}</div>
                </template>
              </Column>
            </DataTable>

          </Panel>
        </div>

      </TabPanel>
    </TabView>

  </div>

</template>

<script>
import CommunityDataService from "../services/community-data.service"
import Promise from "bluebird";

export default {
  name: "profit-list",
  props: {
    matchDayNumberProp: {
      Type: Number,
      default: 1
    }
  },
  data() {
    return {
      profits: {
        userProfits: []
      },
      selectedSubscription: null,
      subscriptions: [],
      filters: {},
      isLoading: false,
      fullPage: true,
      currentIndex: -1,
      internalSubscription: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    },
    subscription() {
      return this.$store.state.sys.subscription;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    }
  },
  methods: {
    getTwoDigitNumber(data){
      return parseFloat(data).toFixed(2);
    },
    getSeasonYear(data) {
      if (data != null) {
        return data.season.seasonYear;
      }
      return "";
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    prepareStateData() {
      return new Promise((resolve, reject) => {

        // no season is selected, check if the current active season and subscriptions are set
        if (this.selectedSubscription == null) {
          this.isLoading = true;

          if (this.internalSubscription == null) {
            this.$store.dispatch('sys/getSubscription')
                .then(() => {
                  this.internalSubscription = this.subscription;
                  // console.log("PrepareStateData: " + JSON.stringify(this.internalSubscription));
                  return this.$store.dispatch('sys/getLastCalculatedMatchDay', this.internalSubscription.season);
                })
                .then(() => {
                  resolve();
                })
                .catch(err => {
                  console.log("Error: " + err.message);
                  reject(err);
                })
          }
        }
      });
    },
    retrieveProfits() {
      this.isLoading = true;

      let requestSubscription = this.internalSubscription;

      if (this.selectedSubscription !== null) {
        requestSubscription = this.selectedSubscription;
      }

      if (requestSubscription == null) {
        this.$store.dispatch('sys/getCurrentSeasonYear')
            .then(() => {
              // console.log("------------------------------------------>");
              return this.$store.dispatch('sys/getSubscription', this.$store.state.sys.seasonYear)
            })
            .then(() => {
              requestSubscription = this.internalSubscription;
              console.log("RequestSubscription: " + JSON.stringify(requestSubscription));
            })
            .catch(err => {
              console.log("Error: " + err.message);
            })
      }

      let data = {}

      if (requestSubscription != null) {
        data.subscriptionId = requestSubscription._id;
      }

      CommunityDataService.getSubscriptionProfits(data)
          .then((data) => {
            console.log("Profits: " + JSON.stringify(data.data));

            this.profits = data.data;
            this.profits.userProfits = data.data.userProfits;
            this.isLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isLoading = false;
          });
    },


    getMatchDayHeader() {
      return this.matchDayNumber + ". Spieltag";
    },

    switchSubscription() {
      this.retrieveProfits();
    },

    rowClass(data) {
      console.log("Current User: " + (data.userId._id === this.currentUser.id));
      return data.userId._id === this.currentUser.id ? 'row-accessories' : null;
    },

    getAllSubscriptions() {
      return new Promise((resolve, reject) => {
        console.log("User DefaultCommunity: " + this.currentUser.defaultCommunity);
        CommunityDataService.getAllSubscriptions(this.currentUser.defaultCommunity)
            .then(subscriptions => {
              // console.log("All subscriptions" + JSON.stringify(subscriptions));
              this.subscriptions = subscriptions.data;
              resolve();
            })
            .catch(err => {
              reject(err);
            })
      });
    }
  },
  mounted() {
    if (!this.currentUser.subscriptions || !this.currentUser.defaultCommunity) {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    } else {
      this.prepareStateData()
          .then(() => {
            console.log("Subscription: " + JSON.stringify(this.internalSubscription));
            return this.getAllSubscriptions();
          })
          .then(() => {
            return CommunityDataService.getCurrentSubscription();
          })
          .then(currentSubscription => {
            // console.log("Current Subscription: " + JSON.stringify(currentSubscription));
            this.internalSubscription = currentSubscription.data;

            this.retrieveProfits();
          })
          .catch(err => {
            console.log("Error: " + err.message);
          })
    }
  }
}
</script>

<style>
.row-accessories {
  background-color: rgb(83, 227, 83) !important;
}

.row-gold-accessories {
  background-color: rgb(212, 175, 55) !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0 #a6d5fa !important;
}

.p-button-rounded:enabled:focus {
  background: transparent;
  box-shadow: 0 0 0 0 #a6d5fa !important;
  border-color: transparent;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  vertical-align: top !important;
}

.p-panel .p-panel-content {
  padding: 0.1rem !important;
}

.p-tabview-panels {
  padding: 0.2rem !important;
}

.p-col-12 {
  padding: 0.2rem !important;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  font-size: 0.6em !important;
}

.calc-points {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.calc-points td, .calc-points th {
  border: 1px solid #ddd;
  padding: 8px;
}

.calc-points tr:nth-child(even) {
  background-color: #f2f2f2;
}

.calc-points tr:hover {
  background-color: #ddd;
}

.calc-points th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #c0c1c0;
  color: white;
}

#season-select .p-inputtext {
  font-size: 0.6rem !important;
}

</style>